import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';



function InstrumentosAdministrativos() {
  const [selectedOption, setSelectedOption] = useState('');

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleLinkButtonClick = () => {
    let link = '';
    if (selectedOption === '1') {link = '../Pdf/PPI2024.pdf';
  } else if (selectedOption === '2') {link = '../Pdf/**********.pdf';
} else if (selectedOption === '3') {link = '../Pdf/**********.pdf';
} else if (selectedOption === '4') {link = '../Pdf/**********.pdf';

    }
    window.open(link, '_blank');
  };

  return (

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div style={{ maxWidth: '300px' }}>
            </div>             
             <Card.Text>Instrumentos Administrativos</Card.Text>
              <Form.Select
                aria-label="Default select example"
                value={selectedOption}
                onChange={handleOptionChange}
              >
                <option>- - -</option>
                <option value="1">PPI2024</option>
                <option value="2">PAC 2024</option>
                <option value="3">MSP 2023 </option>
                <option value="4">MSP 2024 </option>

              </Form.Select>
              <Button variant="primary" onClick={handleLinkButtonClick}>Ver</Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

  );
}

export default InstrumentosAdministrativos;
